import React from "react";
import { getUserData } from "../../utils/utils";
import { Navigate } from "react-router-dom";

interface AuthGardType {
  children: React.JSX.Element;
}

function AuthGard({ children }: AuthGardType) {
  const data = getUserData();
  return data?.access_token ? <Navigate to={"/dashboard"} /> : children;
}

export default AuthGard;
